import { precompileTemplate } from "@ember/template-compilation";
export default precompileTemplate("{{! template-lint-disable no-yield-only }}\n{{yield}}")